<div class="datetime-picker">
    @if (tableStyle) {
        @if (showDate) {
            <input
                [formControl]="datetimeFg.controls.date"
                [matDatepicker]="picker"
                [name]="field.name"
                [placeholder]="field.name"
                (click)="picker.open()"
                matInput
                readonly />

            <mat-datepicker #picker></mat-datepicker>
        }
        <input
            class="time-input"
            #timeTableInput
            [formControl]="datetimeFg.controls.time"
            (click)="timeTableInput.select()"
            matInput
            placeholder="hh:mm"
            type="text" />
    } @else {
        <mat-form-field [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'" appearance="fill">
            <mat-label>{{ field.name }}</mat-label>

            <input
                [formControl]="datetimeFg.controls.date"
                [matDatepicker]="picker"
                [name]="field.name"
                [placeholder]="field.name"
                (click)="picker.open()"
                matInput
                readonly />

            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>

            <mat-datepicker #picker></mat-datepicker>

            <mat-error [control]="fc"></mat-error>
        </mat-form-field>

        <mat-form-field [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'" appearance="fill">
            <mat-label>tijd</mat-label>

            <mat-select [formControl]="datetimeFg.controls.time" placeholder="van" panelWidth="180px">
                @if (times) {
                    @for (day of times; track day.datetime) {
                        <mat-optgroup label="{{ day.datetime | date: 'EEEE d MMM' }}">
                            @for (time of day.options; track time) {
                                <mat-option [disabled]="time.notAvailable" [value]="time.time">
                                    {{ time.datetime | date: 'EEE HH:mm' }}
                                </mat-option>
                            }
                        </mat-optgroup>
                    }
                }
            </mat-select>
        </mat-form-field>
    }
</div>
